module.exports = require('./error-handler');
